import React, { useContext } from 'react';
import { Group } from '@carbon/icons-react';
import { CustomizedTypography } from '@components/Customized';
import {
  CompanyInfoContext,
  CompanyInfoContextValue
} from '../context/CompanyInfoContext';
import { CompanyInfoDetailSection } from './styled';

const CompanyEmployees: React.FunctionComponent = () => {
  const context = useContext<CompanyInfoContextValue | null>(
    CompanyInfoContext
  );

  if (!context) return null;

  const { partnerInfo } = context;
  const numberEmployees = partnerInfo?.numberEmployees;
  const noData = !numberEmployees;

  if (noData) return null;

  return (
    <CompanyInfoDetailSection>
      <div className="data-row">
        <div className="row-title">
          <Group size={20} />
          <CustomizedTypography>회사규모</CustomizedTypography>
        </div>

        {partnerInfo?.numberEmployees ? (
          <CustomizedTypography className="row-value">
            {numberEmployees}
          </CustomizedTypography>
        ) : (
          <CustomizedTypography className="no-data">
            아직 정보가 없습니다
          </CustomizedTypography>
        )}
      </div>
    </CompanyInfoDetailSection>
  );
};

export default CompanyEmployees;
